let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7PGCU")).then(() => parcelRequire('78Hx3'));